export enum CallType {
  Audio = 'Audio',
  Video = 'Video',
  Phone = 'Phone',
}
